import 'bootstrap';

import {AppBar} from './appbar';
import {Comments} from './comments';


const appBar = new AppBar(document.querySelector('.mdc-toolbar'));
const searchScrim = document.querySelector('.appbar-search-scrim');
searchScrim.addEventListener('click', () => {
    appBar.closeSearch();
});

const commentForm = new Comments(document.querySelector('.comment-form'));
